import {Role} from '../../model/role';
import {RoleDto} from '../dto/role.dto';

export function convertRoleModelToDto(role: Role): RoleDto {
  return {
    _id: role.id,
    displayName: role.displayName,
    permissions: role.permissions || null,
    organizationId: role?.organizationId,
    isAdminRole: role?.isAdminRole,
    isSystemRole: role?.isSystemRole,
  };
}
